/* eslint-disable camelcase */
import React from "react";
import "./Flight.css";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { useTranslation } from "../../contexts/TranslationContext";

dayjs.extend(duration);

const Flight = ({
  item,
  onRemove,                      
  selectedDestination,           
  onSelect,                       
}) => {
  const { t } = useTranslation();

  const calcDuration = () => {
    const diff = dayjs(item.date_to).diff(dayjs(item.date_from));
    const d = dayjs.duration(diff);
    let out = "";
    if (d.days())    out += `${d.days()} ${t("DayDuration")} `;
    if (d.hours())   out += `${d.hours()} ${t("H")} `;
    if (d.minutes()) out += `${d.minutes()} ${t("Min")} `;
    return out || `${d.seconds()} ${t("Sec")}`;
  };

  const handleAddClick = () => {
    if (typeof onSelect === "function") {
      onSelect({
        package_component_type: "Flight",
        package_component_id:   item.name,
        destination_row_id:     selectedDestination?.primary_destination_row_id,
        date_from: item.date_from
          ? dayjs(item.date_from).format("YYYY-MM-DD HH:mm:ss")
          : null,
        date_to: item.date_to
          ? dayjs(item.date_to).format("YYYY-MM-DD HH:mm:ss")
          : null,
        from_destination: item.from_destination,
        to_destination:   item.to_destination,
      });
    }
  };

  /* UI */
  return (
    <div className="flight-card">
      {onRemove ? (
        <button className="flight-add-btn remove" onClick={onRemove}>

        </button>
      ) : (
        <button className="flight-add-btn" onClick={handleAddClick}>
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.75 9.75V15C9.75 15.1989 9.67098 15.3897 9.53033 15.5303C9.38968 15.671 9.19891 15.75 9 15.75C8.80109 15.75 8.61032 15.671 8.46967 15.5303C8.32902 15.3897 8.25 15.1989 8.25 15V9.75H3C2.80109 9.75 2.61032 9.67098 2.46967 9.53033C2.32902 9.38968 2.25 9.19891 2.25 9C2.25 8.80109 2.32902 8.61032 2.46967 8.46967C2.61032 8.32902 2.80109 8.25 3 8.25H8.25V3C8.25 2.80109 8.32902 2.61032 8.46967 2.46967C8.61032 2.32902 8.80109 2.25 9 2.25C9.19891 2.25 9.38968 2.32902 9.53033 2.46967C9.67098 2.61032 9.75 2.80109 9.75 3V8.25H15C15.1989 8.25 15.3897 8.32902 15.5303 8.46967C15.671 8.61032 15.75 8.80109 15.75 9C15.75 9.19891 15.671 9.38968 15.5303 9.53033C15.3897 9.67098 15.1989 9.75 15 9.75H9.75Z" fill="white" />
          </svg>
          {/* … */}
        </button>
      )}

      <div className="city city-from">
        <span className="city-name">{item.from_destination_name}</span>
        <span className="airport-code">{item.departure_airport_abbr}</span>
        {item.date_from && (
          <div className="time-info">
            {dayjs(item.date_from).format("MMM D, YYYY · hh:mm A")}
          </div>
        )}
      </div>

      <div className="flight-info">
        <svg className="line-before" width="100" height="1">
          <path d="M0 0.5H100" stroke="#B7B7B7" strokeDasharray="2 2" />
        </svg>

        <div className="flight-duration">
          <span className="airport-name">{item.airline_name}</span>
          <span className="flight-time">{calcDuration()}</span>
        </div>

        <svg className="line-after" width="100" height="6">
          <path d="M100 3L95 0.13V5.87L100 3Z" fill="#B7B7B7" />
          <path d="M0 3V3.5H1.01V3V2.5H0V3Z" fill="#B7B7B7" />
        </svg>
      </div>

      <div className="city city-to">
        <span className="city-name">{item.to_destination_name}</span>
        <span className="airport-code">{item.arrival_airport_abbr}</span>
        {item.date_to && (
          <div className="time-info">
            {dayjs(item.date_to).format("MMM D, YYYY · hh:mm A")}
          </div>
        )}
      </div>
    </div>
  );
};

export default Flight;
